import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  setExchEvent,
  setEventType,
  setCompetition,
  fetchCompetitions,
  fetchEventsByCompetition,
  getInplayEvents,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tooltip,
} from '@material-ui/core';
import './ExchEventsTable.scss';
import { IonCol, IonRow, IonIcon } from '@ionic/react';
import { RootState } from '../../models/RootState';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import InplayImg from '../../assets/images/sportsbook/icons/inplay.svg';
import UpcomingEvent from '../../assets/images/sportsbook/icons/upcomingevent.svg';
import ExchMobOddView from '../ExchOddButton/ExchMobOddView';
import { PlaceBetRequest } from '../../models/BsData';
import { addExchangeBet } from '../../store';
import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import moment from 'moment';
import tvIcon from '../../assets/images/sportsbook/icons/tvIcon.svg';
import tvIconMob from '../../assets/images/sportsbook/icons/tvIcon.svg';
import { useMarketLocalState } from '../../hooks/storageHook';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import {
  isConnected,
  subscribeWsForEventOdds,
  unsubscribeAllWsforEvents,
} from '../../webSocket/webSocket';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { EventDTO } from '../../models/common/EventDTO';
import { SPORTS_ICONS_WITH_ID } from '../../constants/SportsNavView';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

type StoreProps = {
  inplayEvents: InplayEventsObj[];
  setEventType: (event: SelectedObj) => void;
  setCompetition: (event: SelectedObj) => void;
  setExchEvent: (event: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string
  ) => string;
  addExchangeBet: (data: PlaceBetRequest) => void;
  bets: PlaceBetRequest[];
  fetchingEvents: boolean;
  loggedIn: boolean;
};

type selectedRow = {
  runnerId: string;
  rowIndex: string;
};
const InplayEventsTable: React.FC<StoreProps> = (props) => {
  const {
    inplayEvents,
    setEventType,
    setCompetition,
    setExchEvent,
    fetchCompetitions,
    fetchEventsByCompetition,
    addExchangeBet,
    bets,
    fetchingEvents,
    loggedIn,
  } = props;
  const teamTypes = ['home', 'draw', 'away'];
  const [wsChannels, setWsChannels] = useState<string[]>([]);
  const [selectedRow, setSelectedRow] = useState<string>('');
  const history = useHistory();
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const tableFields = [
    {
      key: 'Match',
      Label: 'MATCH',
      className: 'schedule-cell schedule-cell-header',
      align: 'left',
    },
    { key: 'teams', Label: 'TEAMS', className: 'teams-cell', align: 'left' },
    {
      key: 'icons',
      Label: '',
      className: 'schedule-cell odds-web-view',
      align: 'left',
    },
    {
      key: 'homeTeamOdds',
      Label: '1',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'drawOdds',
      Label: 'X',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'awayTeamOdds',
      Label: '2',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'pin',
      Label: '',
      className: 'pin-cell web-view',
      align: 'center',
    },
  ];
  const getOdds = (eventData: EventDTO, teamType: string) => {
    const team =
      teamType === 'home'
        ? eventData.homeTeam
        : teamType === 'away'
        ? eventData.awayTeam
        : teamType;
        
    for (let runner of eventData.matchOdds.runners) {
      if (
        runner?.runnerName?.toLowerCase() === team.toLowerCase() ||
        runner?.runnerName?.toLowerCase().includes(team.toLowerCase())
      ) {
        return [
          {
            type: 'back-odd',
            price: runner?.backPrices[0]?.price,
            size: runner?.backPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner?.runnerName,
          },
          {
            type: 'lay-odd',
            price: runner?.layPrices[0]?.price,
            size: runner?.layPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner?.runnerName,
          },
        ];
      }
    }
    return null;
  };

  const handleEventChange = (iEvent: InplayEventsObj, event: EventDTO) => {
    unsubscribeAllWsforEvents();
    const competitionSlug = event.competitionName
      ? event.competitionName
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, ' ')
          .replace(/ +/g, ' ')
          .trim()
          .split(' ')
          .join('-')
      : 'league';
    setEventType({
      id: iEvent.sportId,
      name: iEvent.sportName,
      slug: iEvent.sportSlug,
    });
    fetchCompetitions(iEvent.sportId);
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: competitionSlug,
    });
    fetchEventsByCompetition(iEvent.sportId, event.competitionId);
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
    history.push(
      `/exchange_sports/${iEvent.sportSlug}/${competitionSlug}/${
        event.eventSlug
      }/${btoa(`${event.sportId}:${event.competitionId}:${event.eventId}`)}`
    );
  };

  // useEffect(() => {
  //   if (loggedIn && inplayEvents.length > 0) {
  //     for (let iEvent of inplayEvents) {
  //       const subs = [...wsChannels];
  //       for (let sEvent of iEvent.events) {
  //         if (sEvent.matchOdds && sEvent.providerName !== 'SportRadar') {
  //           subs.push(sEvent.eventId);
  //           subscribeWsForEventOdds(
  //             sEvent.sportId,
  //             sEvent.competitionId,
  //             sEvent.eventId,
  //             sEvent.matchOdds?.marketId,
  //             sEvent.providerName
  //           );
  //         }
  //       }
  //     }
  //   }
  // }, [isConnected(), inplayEvents, loggedIn]);

  const sorted = (data: any) => {
    return data?.sort((a, b) =>
      a?.eventName?.toLowerCase().localeCompare(b.eventName.toLowerCase())
    );
  };
  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };

  return (
    <div className="events-table-ctn inplay-events-table-ctn">
      {inplayEvents?.length > 0 ? (
        inplayEvents.map((iEvent, inpIdx) => (
          <Accordion className="eventType-accordion" defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="eventType-header"
            >
              <div className="inplay-event-heading">
                <div className="icon-ctn">
                  <img src={SPORTS_ICONS_WITH_ID[iEvent.sportId]} />
                </div>
                {iEvent.sportName}
              </div>
            </AccordionSummary>
            <AccordionDetails className="inplay-events-tbl-container">
              <div className="events-table-content table-ctn">
                <TableContainer component={Paper}>
                  <Table className="events-table inplay-table">
                    <TableHead>
                      <TableRow>
                        {tableFields.map((tF, index) => (
                          <TableCell
                            key={tF.key + index}
                            align={tF.align === 'left' ? 'left' : 'center'}
                            colSpan={tF.colSpan ? tF.colSpan : 1}
                            className={tF.className}
                          >
                            {tF.Label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sorted(iEvent?.events).map((sEvent, idx) => (
                        <React.Fragment key={sEvent?.eventId + idx}>
                          <TableRow
                            onClick={() => handleEventChange(iEvent, sEvent)}
                          >
                            <TableCell
                              className="schedule-cell schedule-cell1 web-view"
                              align="left"
                              onClick={() => handleEventChange(iEvent, sEvent)}
                            >
                              <div className="schedule-ctn">
                                {moment(sEvent.openDate).diff(
                                        moment(),
                                        'minutes'
                                      ) <= 0 ? (
                                  <>
                                    <img src={InplayImg} />
                                    <div className="inply web-view">Inplay</div>
                                  </>
                                ) : (
                                  <div className="schedule">
                                    <div className="schedule-start">
                                      Starting in
                                    </div>
                                    <div>
                                      {moment(sEvent.openDate).diff(
                                        moment(),
                                        'minutes'
                                      )}
                                      '
                                    </div>
                                  </div>
                                )}
                              </div>
                            </TableCell>

                            <TableCell
                              className="teams-cell"
                              style={{ minWidth: '180px' }}
                            >
                              <div className="all-markets-nav-link">
                                {sEvent?.homeTeam !== '' &&
                                sEvent?.awayTeam !== '' ? (
                                  <>
                                    <div
                                      className="odds-web-view"
                                      onClick={() =>
                                        handleEventChange(iEvent, sEvent)
                                      }
                                    >
                                      <IonRow className="temas-col">
                                        <div className="teams">
                                          <div className="team-name">
                                            {sEvent.homeTeam}
                                          </div>
                                          <div className="team-name">
                                            {sEvent.awayTeam}
                                          </div>
                                        </div>
                                      </IonRow>
                                    </div>
                                    <div
                                      className="odds-mob-view lap-view event-info"
                                      onClick={() =>
                                        handleEventChange(iEvent, sEvent)
                                      }
                                    >
                                      {' '}
                                      <div className="mob-icon">
                                        {sEvent?.enableMatchOdds ? (
                                          <>
                                            {!checkIncludeMultiMarket(
                                              multiMarketData,
                                              sEvent.matchOdds?.marketId,
                                              sEvent?.eventId
                                            ) ? (
                                              <Tooltip
                                                title="Add To Multi Markets "
                                                placement="left-start"
                                              >
                                                <img
                                                  src={multipin}
                                                  alt="multipin"
                                                  className="multi-add-icon"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    multiMarketData?.length <
                                                      10 &&
                                                      handleMultiMarket(
                                                        sEvent?.competitionId,
                                                        sEvent?.eventId,
                                                        sEvent.matchOdds
                                                          ?.marketId,
                                                        sEvent?.providerName,
                                                        sEvent?.sportId,
                                                        true
                                                      );
                                                  }}
                                                />
                                              </Tooltip>
                                            ) : (
                                              <Tooltip
                                                title="Remove From Multi Markets"
                                                placement="left-start"
                                              >
                                                <img
                                                  src={removemultipin}
                                                  alt="multipin"
                                                  className="multi-remove-icon"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleMultiMarket(
                                                      sEvent?.competitionId,
                                                      sEvent?.eventId,
                                                      sEvent.matchOdds
                                                        ?.marketId,
                                                      sEvent?.providerName,
                                                      sEvent?.sportId,
                                                      false
                                                    );
                                                  }}
                                                />
                                              </Tooltip>
                                            )}{' '}
                                          </>
                                        ) : null}
                                      </div>
                                      <div className="mob-view event-info">
                                        <div className="event-name">
                                          <span className="event">
                                            {sEvent.eventName}
                                          </span>
                                          <span className="date">
                                            {moment(sEvent.openDate).format(
                                              'DD/MM/YY; hh:mm A'
                                            )}
                                            {moment(sEvent.openDate).diff(
                                              moment(),
                                              'minutes'
                                            ) <= 0 ? null : (
                                              <span>
                                                , Starting in
                                                {moment(sEvent.openDate).diff(
                                                  moment(),
                                                  'minutes'
                                                )}
                                                '
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                        {sEvent ? (
                                          <div className="icon-mob-ctn">
                                            {moment(sEvent.openDate).diff(
                                              moment(),
                                              'minutes'
                                            ) <= 0 ? (
                                              <img
                                                className="icon-market"
                                                src={tvIconMob}
                                                height={16}
                                                width={16}
                                              />
                                            ) : null}
                                            <div className="icon-ctn">
                                              {sEvent?.enablePremium ? (
                                                <div className="p-circle">
                                                  P
                                                </div>
                                              ) : null}
                                              {sEvent?.enableMatchOdds ? (
                                                <div className="mo-circle">
                                                  MO
                                                </div>
                                              ) : null}
                                              {sEvent?.enableBookmaker ? (
                                                <div className="bm-circle">
                                                  BM
                                                </div>
                                              ) : null}
                                              {sEvent?.enableFancy ? (
                                                <div className="f-circle">
                                                  F
                                                </div>
                                              ) : null}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div
                                    className="team-name "
                                    onClick={() =>
                                      handleEventChange(iEvent, sEvent)
                                    }
                                  >
                                    <div className="teams">
                                      <div className="team-name">
                                        {sEvent.eventName}
                                        <span className="date">
                                          {moment(sEvent.openDate).format(
                                            'DD/MM/YY; hh:mm A'
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                <IonRow className="odds-mob-view lap-view odds-row">
                                  {teamTypes.map((teamType, index) => (
                                    <React.Fragment
                                      key={sEvent.eventName + teamType + index}
                                    >
                                      <IonCol className="odds-block">
                                        {sEvent.matchOdds ? (
                                          getOdds(sEvent, teamType) ? (
                                            <>
                                              {getOdds(sEvent, teamType).map(
                                                (odd, index) => (
                                                  <ExchMobOddView
                                                    key={
                                                      sEvent.eventName +
                                                      odd.type +
                                                      odd.price +
                                                      index
                                                    }
                                                    mainValue={odd?.price}
                                                    disable={
                                                      sEvent.matchOdds.status
                                                        .toLowerCase()
                                                        .includes(
                                                          'suspended'
                                                        ) ||
                                                      (sEvent?.sportId ===
                                                        '4' &&
                                                        10 < odd?.price) ||
                                                      (sEvent?.sportId !==
                                                        '4' &&
                                                        20 < odd?.price)
                                                    }
                                                    oddType={
                                                      odd.type === 'back-odd'
                                                        ? 'back-odd'
                                                        : 'lay-odd'
                                                    }
                                                    onClick={() =>
                                                      handleEventChange(
                                                        iEvent,
                                                        sEvent
                                                      )
                                                    }
                                                  />
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="back-odd"
                                              disable={false}
                                              />
                                              <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="lay-odd"
                                              disable={false}
                                              />
                                            </>
                                          )
                                        ) : (
                                          <>
                                            <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="back-odd"
                                              disable={false}
                                            />
                                            <ExchMobOddView
                                              mainValue={'-'}
                                              oddType="lay-odd"
                                              disable={false}
                                            />
                                          </>
                                        )}
                                      </IonCol>
                                    </React.Fragment>
                                  ))}
                                  {/* </>
                                    )} */}
                                </IonRow>
                              </div>
                            </TableCell>

                            <TableCell className="odds-web-view">
                              {sEvent ? (
                                <div className="icon-cell">
                                  {moment(sEvent.openDate).diff(
                                        moment(),
                                        'minutes'
                                      ) <= 0 ? (
                                    <img
                                      className="icon-market"
                                      src={tvIcon}
                                      height={16}
                                      width={16}
                                    />
                                  ) : null}
                                  <div className="icon-ctn">
                                    {' '}
                                    {sEvent?.enablePremium ? (
                                      <div className="p-circle">P</div>
                                    ) : null}
                                    {sEvent?.enableMatchOdds ? (
                                      <div className="mo-circle">MO</div>
                                    ) : null}
                                    {sEvent?.enableBookmaker ? (
                                      <div className="bm-circle">BM</div>
                                    ) : null}
                                    {sEvent?.enableFancy ? (
                                      <div className="f-circle">F</div>
                                    ) : null}
                                  </div>
                                </div>
                              ) : null}
                            </TableCell>
                            {teamTypes.map((teamType, index) => (
                              <TableCell
                                className="odds-cell"
                                align="center"
                                colSpan={2}
                                key={sEvent.eventName + teamType + index}
                              >
                                {sEvent?.matchOdds ? (
                                  getOdds(sEvent, teamType) ? (
                                    <div className="odds-block">
                                      {getOdds(sEvent, teamType).map(
                                        (odd, index) => (
                                          <ExchOddBtn
                                            key={
                                              sEvent.eventName +
                                              odd.type +
                                              odd?.price +
                                              index
                                            }
                                            mainValue={odd?.price}
                                            subValue={odd?.size}
                                            oddType={
                                              odd.type === 'back-odd'
                                                ? 'back-odd'
                                                : 'lay-odd'
                                            }
                                            disable={
                                              sEvent.matchOdds.status
                                                .toLowerCase()
                                                .includes('suspended') ||
                                                moment(sEvent.openDate).diff(
                                                  moment(),
                                                  'minutes'
                                                ) > 0 ||
                                              (sEvent?.matchOdds?.limits
                                                ?.oddsLimit !== 0 &&
                                                sEvent?.matchOdds?.limits
                                                  ?.oddsLimit < odd?.price) ||
                                              (sEvent?.sportId === '4' &&
                                                10 < odd?.price) ||
                                              (sEvent?.sportId !== '4' &&
                                                20 < odd?.price)
                                            }
                                            valueType="matchOdds"
                                            showSubValueinKformat={true}
                                            onClick={() =>
                                              handleEventChange(iEvent, sEvent)
                                            }
                                          />
                                        )
                                      )}
                                    </div>
                                  ) : (
                                    <EmptyOddsBlock
                                      providerName={sEvent.providerName}
                                    />
                                  )
                                ) : (
                                  <EmptyOddsBlock
                                    providerName={sEvent.providerName}
                                  />
                                )}
                              </TableCell>
                            ))}
                            <TableCell className="web-view">
                              {sEvent?.enableMatchOdds ? (
                                <>
                                  {!checkIncludeMultiMarket(
                                    multiMarketData,
                                    sEvent.matchOdds?.marketId,
                                    sEvent?.eventId
                                  ) ? (
                                    <Tooltip
                                      title="Add To Multi Markets "
                                      placement="left-start"
                                    >
                                      <img
                                        src={multipin}
                                        alt="multipin"
                                        className="multi-add-icon"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          multiMarketData?.length < 10 &&
                                            handleMultiMarket(
                                              sEvent?.competitionId,
                                              sEvent?.eventId,
                                              sEvent.matchOdds?.marketId,
                                              sEvent?.providerName,
                                              sEvent?.sportId,
                                              true
                                            );
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Remove From Multi Markets"
                                      placement="left-start"
                                    >
                                      <img
                                        src={removemultipin}
                                        alt="multipin"
                                        className="multi-remove-icon"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleMultiMarket(
                                            sEvent?.competitionId,
                                            sEvent?.eventId,
                                            sEvent.matchOdds?.marketId,
                                            sEvent?.providerName,
                                            sEvent?.sportId,
                                            false
                                          );
                                        }}
                                      />
                                    </Tooltip>
                                  )}{' '}
                                </>
                              ) : null}
                            </TableCell>
                          </TableRow>
                          {bets.length > 0 &&
                          selectedRow === sEvent?.sportId + idx ? (
                            <TableRow className="inply-row mob-view">
                              <TableCell
                                className={'teams-cell betslip-cell'}
                                colSpan={3}
                              >
                                <div className={bets[0].betType + '-betslip'}>
                                  <ExchBetslip mobileView={true} />
                                </div>
                              </TableCell>
                              <TableCell
                                className="cell1"
                                colSpan={2}
                                style={{ width: '0px' }}
                              ></TableCell>
                            </TableRow>
                          ) : null}
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </AccordionDetails>
          </Accordion>
        ))
      ) : !fetchingEvents ? (
        <div className="events-table-msg-text">No Inplay Events</div>
      ) : null}
    </div>
  );
};

function EmptyOddsBlock(props: { providerName: string }) {
  const { providerName } = props;

  return (
    <React.Fragment>
      <div className="odds-block">
        <ExchOddBtn
          mainValue={'-'}
          subValue={null}
          disable={false}
          oddType="back-odd"
        />
        <ExchOddBtn
          mainValue={'-'}
          subValue={null}
          disable={false}
          oddType="lay-odd"
        />
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    fetchingEvents: state.exchangeSports.fetchingEvents,
    bets: state.exchBetslip.bets,
    inplayEvents: getInplayEvents(state.exchangeSports.events),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eType: SelectedObj) => dispatch(setEventType(eType)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    fetchEventsByCompetition: (etId: string, cId: string) =>
      dispatch(fetchEventsByCompetition(etId, cId, [])),
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InplayEventsTable);
